/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/util/isScheduler.js
// module id = 24
// module chunks = 0